import { render, staticRenderFns } from "./Statistik.vue?vue&type=template&id=a0d1461e&scoped=true&"
import script from "./Statistik.vue?vue&type=script&lang=js&"
export * from "./Statistik.vue?vue&type=script&lang=js&"
import style0 from "./Statistik.vue?vue&type=style&index=0&id=a0d1461e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d1461e",
  null
  
)

export default component.exports